export enum TOKEN {
  /** Verification Header */
  HEADER = "vHdr",
  /** Verification Payload */
  PAYLOAD = "vPl",
  /** Verification Signature */
  SIGNATURE = "vSg",
}

export enum USER_TYPE {
  SUPER_ADMIN = "IDSS User",
  ADMIN = "Organization Admin",
  STAFF = "Organization Staff",
  GUEST = "IDSS Guest",
  USER = "User",
  GUARDIAN = "Guardian",
  STUDENT = "Student",
}

export enum APP {
  ORGANIZATION_ID = "orgId",
  USER_TYPE = "uType",
  EMAIL = "eMail",
  FULL_NAME = "fLNe",
  EXPANDED_NAVBAR = "edNav",
  UNIQUE_LINK = "uniqL",
  USER_NAME = "uID",
}

export enum PAGES {
  DASHBOARD = "/",
  MODULES = "/modules",
  DEPARTMENTS = "/departments",
  COURSES = "/courses",
  CLASSROOM = "/classroom",
  SIGNIN = "/signin",
  SIGNUP = "/signup",
  OTP = "/otp",
  UPLOADS = "/uploads",
  RESET_PASSWORD = "/reset-password",
  PROFILE_PREVIEW = "/profile-preview",
  IDENTITY = "/identity",
  ONBOARDING = "/onboarding",
  FORGOT_PASSWORD = "/forgot-password",
  LEARNING_GROUPS = "/learning-modules",
  COURSE_MANAGEMENT = "/course-management",
  COURSE_FEEDBACKS = "/course-feedbacks",
  ORG_MANAGEMENT = "/org-management",
  LESSONS = "/lessons",
  TOPIC = "/topic",
  TOPICS = "/topics",
  LEADER_BOARD = "/leader-board",
  USER_MANAGEMENT = "/user-management",
  SUBJECT_MANAGEMENT = "/subject-management",
  STUDENT_MANAGEMENT = "/student-management",
  SYLLABUS = "/syllabus",
  QUESTION_BANK = "/question-bank",
  TECHNICAL_SESSION = "/technical-session",
  ASSESSMENT = "/assessment",
  LIVE_SESSIONS = "/live-sessions",
  PRICING_PLAN = "/pricing-plan",
  NOTIFICATIONS = "/notifications",
  ADMIN_USERS = "/admin-users",
  SETTINGS = "/settings",
  HELP_CENTER = "/help-center",
  LOGOUT = "/logout",
  NOT_FOUND = "/404",
  SUBJECTS = "/subjects",
  QUEST = "/quest",
  PLAN = "/plan",
}

export enum MODALS {
  // assessments
  CREATE_ASSESSMENT = "create-assessment",
  CREATE_PROFESSIONAL_EXAM = "create-professional-exam",

  // chapter content
  ADD_CHAPTER_CONTENT = "add-chapter-content",
  EDIT_CHAPTER_CONTENT = "edit-chapter-content",

  // chapter
  ADD_NEW_CHAPTER = "add-new-chapter",
  EDIT_CHAPTER = "edit-chapter",

  // course
  CREATE_COURSE = "create-course",
  EDIT_COURSE = "edit-course",

  DOWNLOAD_SYLLABUS = "download-syllabus",

  SUBJECT_COMBINATION_UPDATE = "subject-combination-update",
  USER_PROFILE_UPDATE = "user-profile-update",
  UTME_PACKAGE = "utme-package",

  // department
  CREATE_DEPARTMENT = "create-module",
  EDIT_DEPARTMENT = "edit-module",
  SHOW_PDF = "show-pdf",

  // group
  CREATE_GROUP = "create-group",
  EDIT_GROUP = "edit-group",

  // question
  ADD_QUESTION = "add-question",
  CREATE_QUESTION_BANK = "create-question-bank",
  EDIT_QUESTION = "edit-question",

  // user
  CHANGE_PASSWORD = "change-password",
  EDIT_PROFILE = "edit-profile",
  TWO_FACTOR_AUTHENTICATION = "two-factor authentication",

  //settings
  ADD_ROLE = "add-role",
  EDIT_ROLE = "edit-role",

  // staff
  ADD_INSTRUCTOR = "add-instructor",
  ONBOARD_STAFF = "onboard-staff",
  CREATE_ADMIN = "create-admin",
  EDIT_ADMIN = "edit-admin",

  //ord management
  ONBOARD_ORG = "onboard-organization",
  EDIT_ORG = "edit-organization",

  // assessment
  EDIT_ASSESSMENT = "edit-assessment",
  UPLOAD_QUESTION_CSV = "upload-question-csv",
  UPLOAD_STAFF_CSV = "upload-staff-csv",
  UPLOAD_FILE = "upload-file",

  EXAM_MODE = "exam-mode",
  WRITE_REVIEW = "write-review",
  BOOK_DEMO = "book-demo",
  ADD_CAREER_PATH = "add-career-path",
  CREATE_SESSION = "create-session",

  CREATE_UMTE_YEAR = "create-umte-year",
  EDIT_UMTE_YEAR = "edit-umte-year",

  // ranks
  ADD_RANK = "add-rank",
  EDIT_RANK = "edit-rank",
}

export enum SUBJECT_PATHS {
  SCIENCE = "Science",
  ART = "Art",
  COMMERCIAL = "Commercial",
}
